/* libs/iot-platform/iot-platform-ui-users/src/lib/components/user-detail-dialog/user-detail-dialog.component.scss */
.user-detail-dialog--title {
  word-break: break-all;
  font-size: 18px;
}
.user-detail-dialog--title:hover {
  cursor: pointer;
  text-decoration: underline;
}
.user-detail-business-profile-list {
  max-height: 200px;
  overflow-y: auto;
  padding-left: 4px;
}
.user-detail-business-profile-list li {
  max-height: 31px;
}
.capitalize-first-letter {
  display: inline-block;
}
.out-of-scope-bp-message {
  font-size: 10px;
}
.user-detail-no-bp-message {
  height: 31px;
}
.user-detail-popup-status > span {
  margin-right: 10px;
}
.animate {
  animation: fadein 1s cubic-bezier(0.4, 0.2, 0.59, 0.92);
}
@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
/*# sourceMappingURL=user-detail-dialog.component.css.map */
